import { Component, Input } from '@angular/core';

@Component({
  selector: 'icon-nbc',
  template: `<i nz-icon
                [ngStyle]="styles">
    <svg id="Layer_1"
         data-name="Layer 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 162.98 92.22">
      <title>NBC Logo</title>
      <path d="M21.28,40.57a16.51,16.51,0,0,1,2.33-4.67c0.41-.55.82-1.17,1.3-1.72A17.18,17.18,0,0,1,27.19,32a16.33,16.33,0,0,1,7-3.16Q41.6,27.49,47,31.1a8.63,8.63,0,0,0,1.3.89,18.6,18.6,0,0,1,2.4,2.2c0.41,0.48.76,1,1.1,1.37a30.81,30.81,0,0,1,2.47,5c0.21,0.48.41,1,.69,1.58L77.23,93.3,27.73,59.45a14.79,14.79,0,0,1-4.46-4.53,19.61,19.61,0,0,1-2.4-6.38A15.51,15.51,0,0,1,21.28,40.57Zm1.72,58a15.1,15.1,0,0,1-7.28-1.85,15.87,15.87,0,0,1-4.6-3.3,17.43,17.43,0,0,1,0-23.89,18.88,18.88,0,0,1,3-2.4A15.43,15.43,0,0,1,23,64.33a18.57,18.57,0,0,1,6.52,1,20.5,20.5,0,0,1,3.29,1.78c0.89,0.48,1.85,1.17,3,1.85L79.7,98.58H23ZM85.68,29.66l-8,56.23L53.41,30.21a16.66,16.66,0,0,1-.34-12.36c0.07-.21.21-0.48,0.27-0.69A16,16,0,0,1,62.2,8a24.25,24.25,0,0,1,2.88-1,16,16,0,0,1,8.44,0A9.66,9.66,0,0,1,75,7.41c4.67,1.78,7.9,4.67,9.68,8.72,0.21,0.62.48,1.17,0.62,1.72a17.16,17.16,0,0,1,1,4.67A40.56,40.56,0,0,1,85.68,29.66Zm38.3,5.9a8.8,8.8,0,0,1,1.1-1.37,24.25,24.25,0,0,1,2.33-2.2,14.85,14.85,0,0,0,1.31-.89q5.36-3.6,12.77-2.26A16.18,16.18,0,0,1,148.56,32a17.17,17.17,0,0,1,2.26,2.2c0.48,0.55.89,1.17,1.3,1.72a16.91,16.91,0,0,1,3,8.79,14.65,14.65,0,0,1-.35,3.84c-0.14.82-.41,1.72-0.62,2.47a17.31,17.31,0,0,1-1.51,3.43,1.09,1.09,0,0,1-.27.48,14.79,14.79,0,0,1-4.46,4.53L98.44,93.3l22.31-51.15A42.09,42.09,0,0,1,124,35.56ZM90.76,34.19A7.57,7.57,0,0,1,90.9,32a4.21,4.21,0,0,1,1.17-2.33l1.44-1.17,1.17-.76c1.51-.62,2.2-1.17,1.85-1.51s-1.1-.55-2.47-0.69h-4.6V25.2a16.88,16.88,0,0,1,.82-7.35c0.21-.55.48-1.1,0.69-1.72a16.53,16.53,0,0,1,9.68-8.72,9.92,9.92,0,0,1,1.51-.48,16,16,0,0,1,8.44,0,24.31,24.31,0,0,1,2.88,1,16.19,16.19,0,0,1,8.85,9.2c0.07,0.21.21,0.48,0.27,0.69a16.64,16.64,0,0,1-.27,12.36L98,85.88,90.83,35.22A5.61,5.61,0,0,1,90.76,34.19Zm78.53,49.5a13.48,13.48,0,0,1-.48,2.4A15.73,15.73,0,0,1,165,93l-0.48.48a28,28,0,0,1-2.33,2,16.22,16.22,0,0,1-9.54,3.16H96L139.91,69c1.1-.69,2.06-1.37,3-1.85a20.34,20.34,0,0,1,3.36-1.78,17.91,17.91,0,0,1,6.45-1,16.08,16.08,0,0,1,5.08.82,14.24,14.24,0,0,1,3.77,2,19.22,19.22,0,0,1,3,2.4,14.84,14.84,0,0,1,1.65,2,16.16,16.16,0,0,1,3.16,10C169.36,82.25,169.36,83,169.29,83.69Z"
            transform="translate(-6.38 -6.37)"/>
    </svg>
  </i>`
})
export class NBCIcon {

  @Input() color: string = '';

  @Input('font-size') fontSize: string = '';

  @Input() width: string = '';

  get styles() {

    const css: any = {};

    if (this.color) {

      css.color = this.color;
    
    }

    if (this.fontSize) {

      css['font-size'] = this.fontSize;
    
    }

    if (this.width) {

      css.width = this.width;
    
    }
    
    return css;

  }

}
